export default __webpack_public_path__ + "static/media/Animals_28.14bd7132.png";